// extracted by mini-css-extract-plugin
export default {"screenCardMirror":"d8NMm9Jto377Y9vDaMpo"};